import { createApi } from '@reduxjs/toolkit/query/react';
import { FetchBaseQuery } from './FetchBaseQuery';

export const currencyApi = createApi({
    reducerPath: 'currencyApi',
    baseQuery: FetchBaseQuery,
    endpoints: (builder) => ({
        getCurrencies: builder.query({
            query: () => ({
                url: `/currency`,
                method: 'GET',
            }),
            async onQueryStarted(queryArg, { queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                } catch (err) {
                    return err;
                }
            },
        }),
    }),
});

export const { useGetCurrenciesQuery } = currencyApi;